import React from 'react';

const Categories = () => <h1>Under Construction</h1>;

export default Categories;
